export interface FormTagListStyling {
    style: FormTagListStyle;
    modifiers: FormTagListStyleModifier[];
    color?: FormTagListTagColor;
    truncate: boolean;
}

export type FormTagListStyle = 'Default' | 'Embedded';

export enum FormTagListStyleModifier {
    NoBorder = '-sh-remove-border'
}

export enum FormTagListTagColor {
    Default = 'sh-tag',
    Red = 'sh-tag--error',
    Orange = 'sh-tag--warning',
    Green = 'sh-tag--success',
    Blue = 'sh-tag--update',
    Brand = 'sh-tag--brand'
}
